import { vm } from "../socket/config.js";
import { blocklyWorkspace } from "../index.js";
import { isWorkspaceAccesable } from "../utils/dom.js";
import { setPauseEventHandling } from "../vm/overrides.js";
import { setLocalFlag } from "../utils/scratch-helpers.js";

let isLocalBackdrop = false;

export const onBackdropAdded = async (data) => {
    const msg = data.data;
    if (!msg?.ret || !Array.isArray(msg.ret) || msg.ret.length < 2) {
        console.warn("Invalid backdropAdded data:", data);
        return;
    }

    const [backdropName, backdropData] = msg.ret;
    const stage = vm.runtime.getTargetForStage();
    if (!stage) {
        console.error("Stage target not found");
        return;
    }

    setLocalFlag(true);
    setPauseEventHandling(true);
    try {
        const originalTarget = vm.editingTarget;

        const dataBuffer = Uint8Array.from(backdropData.assetData);
        const asset = await vm.runtime.storage.createAsset(
            backdropData.asset.assetType,
            backdropData.asset.dataFormat,
            dataBuffer,
            backdropData.assetId,
            true,
        );

        const backdropObj = {
            name: backdropData.name,
            dataFormat: backdropData.dataFormat,
            asset: asset,
            md5:
                backdropData.md5 ||
                `${asset.assetId}.${backdropData.dataFormat}`,
            assetId: asset.assetId,
            ...(backdropData.rotationCenterX !== undefined && {
                rotationCenterX: backdropData.rotationCenterX,
            }),
            ...(backdropData.rotationCenterY !== undefined && {
                rotationCenterY: backdropData.rotationCenterY,
            }),
        };

        vm.addBackdrop(backdropName, backdropObj);

        if (isWorkspaceAccesable() && blocklyWorkspace) vm.emitTargetsUpdate();

        if (originalTarget && vm.runtime.getTargetById(originalTarget.id)) {
            vm.editingTarget = originalTarget;
            vm.runtime._editingTarget = originalTarget;
        }
    } catch (e) {
        console.error("Error adding remote backdrop:", e);
    } finally {
        setPauseEventHandling(false);
    }
};

export { isLocalBackdrop };
